<template>
	<v-text-field class="ma-0 pa-0 right-aligned" background-color="grey darken-2" height="20" style="font-size: 10pt;"
        hide-details dense solo readonly
        :ref="refname" :key="day"
        v-model="inputValue"
        :prefix="prefix"
    ></v-text-field>
</template>
<script>
export default {
    name: 'DecInput',
    props: ['day', 'prefix', 'refname', 'value'],
    data: () => ({
        inputValue: null,
    }),
    computed: {
    },
    mounted() {
        this.inputValue = this.getInputValue(this.value)
    },
    beforeDestroy() {
        //console.log('DecView about to be destroyed')
    },
    methods: {
        getInputValue(value) {
            if (!value || value == '') return null
            return parseFloat(value).toFixed(2).replace(',', '').replace('.', ',')
        },
    },
	watch: {
		value (val) {
            //console.log('watcher:', val, this.value, typeof(this.value))
            //if(val) this.inputValue = this.getInputValue(this.value)
            this.inputValue = this.getInputValue(this.value)
		},
	},
}
</script>
<style scoped>
.right-aligned >>> input {
    text-align: end;
}

</style>